import { Component, computed, signal } from "@angular/core";

import { LiquidElementText, LiquidText } from "../../../liquid-page.models";

@Component({
    selector: 'meta-liquid-text',
    templateUrl: './liquid-text.component.html',
    styleUrls: ['./liquid-text.component.css'],
})
export class LiquidTextComponent {
    $input = signal<LiquidElementText | undefined>(undefined);
    $output = computed<LiquidText>(() => {
        if (this.$input() && this.$input()?.id === "id-1") {
            return { tag: 'span', value: this.$input()?.value };
        } else if (this.$input()) {
            return { tag: 'p', value: this.$input()?.value };
        }

        return { tag: undefined };
    })
}